type LivenessRuntimeConfig = {
    apiBaseUrl?: string;
    appBasePath?: string;
    captureStyle?: string;
};

declare global {
    interface Window {
        __LIVENESS_CONFIG__?: LivenessRuntimeConfig;
    }
}

export function getApiBaseUrl(): string | undefined {
    const runtimeApiBaseUrl =
        typeof window === 'undefined' ? undefined : window.__LIVENESS_CONFIG__?.apiBaseUrl;
    const apiBaseUrl = runtimeApiBaseUrl || process.env.REACT_APP_API_BASE_URL;

    if (!apiBaseUrl) {
        return undefined;
    }

    return apiBaseUrl.replace(/\/+$/, '');
}

export type CaptureStyle = 'incode' | 'legacy';

// Capture screen look for the Incode 2.x engine. The Incode-style screen is
// the default; set 'legacy' to fall back to the previous dashed-oval screen.
export function getCaptureStyle(): CaptureStyle {
    const runtimeStyle =
        typeof window === 'undefined' ? undefined : window.__LIVENESS_CONFIG__?.captureStyle;
    const style = runtimeStyle || process.env.REACT_APP_INCODE_CAPTURE_STYLE;

    return style === 'legacy' ? 'legacy' : 'incode';
}

export function getAppBasePath(): string {
    const runtimeAppBasePath =
        typeof window === 'undefined' ? undefined : window.__LIVENESS_CONFIG__?.appBasePath;
    const appBasePath = runtimeAppBasePath || process.env.REACT_APP_APP_BASE_PATH || '/';
    const normalizedPath = appBasePath.startsWith('/') ? appBasePath : `/${appBasePath}`;

    return normalizedPath.length > 1 ? normalizedPath.replace(/\/+$/, '') : '/';
}

// Absolute URL of the app's entry page, e.g. "https://host/identity/". Keeps the
// trailing slash so nginx serves the app directly instead of redirecting.
export function getAppRootUrl(): URL {
    const appBasePath = getAppBasePath();

    return new URL(appBasePath === '/' ? '/' : `${appBasePath}/`, window.location.origin);
}

export {};
